import { format, startOfWeek, startOfMonth, startOfYear, subMonths, endOfMonth, subYears, endOfYear } from "date-fns";

const iso = (d) => format(d, "yyyy-MM-dd");
const span = (from) => () => { const t = new Date(); return { date_from: iso(from(t)), date_to: iso(t) }; };

export const RANGE_PRESETS = [
  { k: "today", l: "Bugün", range: span((d) => d) },
  { k: "week", l: "Bu hafta", range: span((d) => startOfWeek(d, { weekStartsOn: 1 })) },
  { k: "month", l: "Bu ay", range: span((d) => startOfMonth(d)) },
  { k: "3months", l: "Son 3 ay", range: span((d) => subMonths(d, 3)) },
  { k: "year", l: "Bu yıl", range: span((d) => startOfYear(d)) },
];

const fixed = (from, to) => () => { const t = new Date(); return { date_from: iso(from(t)), date_to: iso(to(t)) }; };
const [TODAY, WEEK, MONTH, THREE, YEAR] = RANGE_PRESETS;
export const DASHBOARD_PRESETS = [
  TODAY, WEEK, MONTH,
  { k: "lastMonth", l: "Geçen ay", range: fixed((d) => startOfMonth(subMonths(d, 1)), (d) => endOfMonth(subMonths(d, 1))) },
  THREE, YEAR,
  { k: "lastYear", l: "Geçen yıl", range: fixed((d) => startOfYear(subYears(d, 1)), (d) => endOfYear(subYears(d, 1))) },
];

export const matchPreset = (presets, range) =>
  presets.find((p) => { const r = p.range(); return r.date_from === range.date_from && r.date_to === range.date_to; })?.k;

export const PeriodPresets = ({ presets, active, onPick, testPrefix }) => (
  <div className="flex flex-wrap gap-1.5" data-testid={`${testPrefix}-presets`}>
    {presets.map((p) => (
      <button key={p.k} type="button" onClick={() => onPick(p)} data-testid={`${testPrefix}-preset-${p.k}`}
              className={`px-3 py-1 rounded-full text-xs border transition-colors ${active === p.k
                ? "bg-emerald-700 text-white border-emerald-700" : "bg-white text-slate-700 border-slate-300 hover:border-emerald-600"}`}>
        {p.l}
      </button>
    ))}
  </div>
);
